import {sigTooltipHandler} from './file_signatures';
import {findApplicant} from './rating_applicants';
import {isMobile} from "./helpers";

function setContentMarginBottom() {
    const element = document.getElementById('vikon-footer');
    if (element) {
        const footerHeight = document.getElementById('vikon-footer').offsetHeight;
        $_vikon('#vikon-section').css('margin-bottom', `${footerHeight}px`);
    }
}

function setHashUrlFromEl(domObj) {
    const hashForElement = domObj.attr('href');
    if (hashForElement !== 'undefined' && hashForElement.indexOf('#') === 0 && hashForElement.indexOf('#tr_anchor_') !== 0) {
        if (window.history && history.pushState) {
            // IE10, Firefox, Chrome, etc.
            window.history.replaceState(null, null, hashForElement);
        } else {
            // old
            const pos = $_vikon(window).scrollTop(); // get scroll position
            window.location.hash = hashForElement;
            $_vikon(window).scrollTop(pos); // set scroll position back
        }
    }

    if (hashForElement.indexOf('#tr_anchor_') === 0) {
        const result = hashForElement.replace(/\./g, '\\\.');
        const targetElement = $_vikon(result);
        if (targetElement.length > 0) {
            // Вычисляем высоту шапки таблицы
            const tableHeaderHeight = targetElement.closest('table').find('thead').outerHeight() || 0;

            // Прокручиваем страницу к элементу с учетом высоты шапки таблицы
            $_vikon('html, body').animate({scrollTop: targetElement.offset().top - tableHeaderHeight}, 500);
        }
    }
}

function openPathToElem(pathToElem) {

    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const isMobileUser = isMobile.any() !== null;

    if (pathToElem.length > 0) {
        $_vikon.each(pathToElem, (index, piecePath) => {
            const tab = $_vikon('.vikon-tabs, #nav-menu-list').find(`${' a[href="' + '#'}${piecePath}"]`);
            if (tab.length > 0) {
                tab.tab('show');
            } else {
                setTimeout(() => {
                    if ($_vikon(`#${piecePath}`).length) {
                        if (isMobileUser && isInViewport(document.getElementById(piecePath))) {
                            return
                        }

                        $_vikon('html,body').animate({scrollTop: $_vikon(`#${piecePath}`).offset().top}, 'high');
                    }
                }, 600);
            }
        });
    }
}

function createOpenPathToElem(domObj) {
    const hashPieces = [];
    const hashForElement = domObj.attr('id');
    if (hashForElement !== 'undefined') {
        hashPieces.unshift(hashForElement);
        const parentsPanes = $_vikon(domObj.parents('.vikon-tab-pane'));
        $_vikon.each(parentsPanes, (index, tabPane) => {
            if ($_vikon(tabPane).attr('id') !== 'undefined') {
                hashPieces.unshift($_vikon(tabPane).attr('id'));
            }
        });
    }
    return hashPieces;
}

$_vikon(window).on('resize', () => {
    setContentMarginBottom();
});

$_vikon(document).ready(() => {
    setContentMarginBottom();
    const {hash} = location;
    if (hash.replace('#', '')) {
        if (hash.indexOf('#abitur_') >= 0) { //абитуриенту
            const newHash = hash.replace('#abitur_', '');
            $_vikon('[id=abitur-hrefs]').find(`[data-href=${newHash}]`).click();
        } else if (hash.indexOf('#anchor_') === 0) { //загловки с анчорами в сведениях
            const el = $_vikon(hash);
            if (el.length === 1) {
                openPathToElem(createOpenPathToElem(el));
            }
        } else if (hash.indexOf('#tr_anchor_') === 0) { //ряды в таблицах
            const el = $_vikon(`.anchor-link[href="${hash}"]`);
            if (el.length > 0) {
                setTimeout(() => {
                    const scrollableTableHead = $_vikon(el).closest('.table-scroll-thead');
                    const offset = scrollableTableHead.data('table-id') !== undefined //временое решение
                        ? scrollableTableHead.find('thead').height()
                        : 0;
                    $_vikon('html,body').animate({scrollTop: el.offset().top - offset - 7}, 'high');
                }, 500);
            }
        }
    }

    $_vikon('.open-tooltip-anchor').tooltip({
        placement: 'left',
        scrollableElement: 'html,body',
        template: '<span class="anchor-tooltip-wrap text-primary" role="tooltip" >'
            + '<span class="tooltip-inner transparent"></span></span>',
        trigger: 'hover focus',
        title() {
            return `<a  class="anchor-get"  href="#${$_vikon(this).attr('id')}">`
                + '<span class="fa fa-link" aria-hidden="true"></span>'
                + '</a>';
        },
        html: true,
        delay: {show: 50, hide: 1600},
    });

    $_vikon(document)
        .on('click', '.anchor-get, #nav-menu-list a, .vikon-tabs .vikon-nav-link', function (e) {
            setHashUrlFromEl($_vikon(this));
        })
        .on('click', '#abitur_stoimost_link', (e) => {
            openPathToElem(createOpenPathToElem($_vikon('#anchor_paidEduStoimDocLink')));
        })
        .on('click', '.resizing-box + .read-more .button', function () {
            const $elem = $_vikon(this).parent().prev('.resizing-box');
            $_vikon('.anchor-tooltip-wrap').remove();
            if ($elem.hasClass('short')) {
                $elem.removeClass('short');
                $_vikon(this).text('Свернуть');
            } else {
                $elem.addClass('short');
                $_vikon(this).text('Развернуть');
            }
        })
        .on('click', '.tr-accordion', function () {
            const $currentTr = $_vikon(this);
            const span = $currentTr.find('span.fa');
            const label = $currentTr.find('span.show-or-hide-text');
            const $table = $currentTr.closest('table');
            const id = $currentTr.data('id');
            if (!span.hasClass('fa-minus')) {
                span.addClass('fa-minus');
                label.html('&nbsp;Скрыть');
                $table.find(`tr[data-tr-id=${id}]`).show();
            } else {
                span.removeClass('fa-minus');
                label.html('&nbsp;Показать');
                $table.find(`tr[data-tr-id=${id}]`).hide();
            }
        });

    $_vikon('body').tooltip({
        selector: '.tooltip-sig',
        html: true,
        title: sigTooltipHandler,
        placement: 'auto',
    });

    if (!$_vikon('[name=data_remote_uri]').length) {
        findApplicant();
    }

    $_vikon('[data-toggle="popover"]').popover();
});
